/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { CatalogLocationSeoFieldsAdmin } from './CatalogLocationSeoFieldsAdmin'
import {
  CatalogLocationSeoFieldsAdminFromJSON,
  CatalogLocationSeoFieldsAdminFromJSONTyped,
  CatalogLocationSeoFieldsAdminToJSON,
} from './CatalogLocationSeoFieldsAdmin'

/**
 *
 * @export
 * @interface PaginatedCatalogLocationSeoFieldsAdmin
 */
export interface PaginatedCatalogLocationSeoFieldsAdmin {
  /**
   *
   * @type {Array<CatalogLocationSeoFieldsAdmin>}
   * @memberof PaginatedCatalogLocationSeoFieldsAdmin
   */
  results: Array<CatalogLocationSeoFieldsAdmin>
  /**
   *
   * @type {number}
   * @memberof PaginatedCatalogLocationSeoFieldsAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedCatalogLocationSeoFieldsAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedCatalogLocationSeoFieldsAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedCatalogLocationSeoFieldsAdmin interface.
 */
export function instanceOfPaginatedCatalogLocationSeoFieldsAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedCatalogLocationSeoFieldsAdminFromJSON(
  json: any,
): PaginatedCatalogLocationSeoFieldsAdmin {
  return PaginatedCatalogLocationSeoFieldsAdminFromJSONTyped(json, false)
}

export function PaginatedCatalogLocationSeoFieldsAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedCatalogLocationSeoFieldsAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(CatalogLocationSeoFieldsAdminFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedCatalogLocationSeoFieldsAdminToJSON(
  value?: PaginatedCatalogLocationSeoFieldsAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(CatalogLocationSeoFieldsAdminToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
